import moment from "moment";
import _ from "lodash";

export const distribuiHorasPorSentido = (horarios, sentido) =>
  horarios.filter(horario => horario.deSentido === sentido.toUpperCase());

export const distribuiHorasPorDia = horarios =>
  ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB', 'DOM'].map(day =>
    horarios.filter(horario => horario.deDiaSemana === day)
  );

/**
 * Apaga a lista de horários vinculados a o dia da semana escolhido.
 * O dia da semana é um indice de um array de seg a dom, iniciando com índice 0 (0 = "segunda")
 * @param {*} horariosArr array com todos os horários
 * @param {*} diaIdx índice do dia da semana a ser excluído
 * @param {*} rota qual o sentido deve ser alterado: "IDA" ou "VOLTA"
 * @returns array com todos os horários e com os horários do dia da semana escolhido com a prop `boExcluido === true`
 */
export const excluiHorariosDoDia = (horariosArr, dia, rota) => {
  if(!horariosArr) return [];
  return horariosArr.map(entry =>
    entry.deDiaSemana.toUpperCase() === dia.toUpperCase() &&
    entry.deSentido === rota.toUpperCase()
      ? { ...entry, boExcluido: true }
      : entry
  );
};

/**
 * Apaga o horário com o ID informado.
 * @param {*} horaroisArr array com todos os horários
 * @param {*} horarioId ID do horário selecionado (`cdLinhaQuadroHorioHora`)
 * @returns array com todos os horários e com o horário escolhido com a prop `boExcluido === true`
 */
export const excluiHorario = (horariosArr, horarioId) => {
  if(!horariosArr) return [];
  return horariosArr.map(entry =>
    entry.cdLinhaQuadroHorarioHora === Number(horarioId) ? { ...entry, boExcluido: true } : entry
  );
};

/**
 * Limpa o quadro de horários, marcando todos os registros com `boExcluido === true`
 * @param {*} schedulesData listagem orignal de horários
 * @returns array com todos os horários com a prop `boExcluido === true`
 */
export const onClearBoard = (schedulesData) => {
  return schedulesData.map(entry => {
    const temp = {...entry};
    temp.boExcluido = true;
    return temp;
  });
}

/**
 * Ordena listagem pelo horário
 * @param {*} schedulesData listagem orignal de horários
 * @returns array ordenado com todos os horários originais enviados
 */
export const hoursOrder = (schedulesData) => {
  let temp = [...schedulesData];
  temp  = _.orderBy(temp, (entry) => moment(entry.hrHorario).format('HH:mm'), 'asc');
  return temp;
}

export const hoursOrderByWeekDay = (schedulesData, route) => {
  let times = [...schedulesData];
  let total = 0;
  if(route){
    times = times.filter(hr => hr.deSentido === route);
  }
  times  = _.orderBy(times, (entry) => moment(entry.hrHorario).format('HH:mm'), 'asc');
  total = times.length;
  times = distribuiHorasPorDia(times);
  return { times, total };
}
